import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'

import useAtmosphere from '../hooks/useAtmosphere'
import useMutationProps from '../hooks/useMutationProps'
import ToggleSummaryEmailMutation from '../mutations/ToggleSummaryEmailMutation'
import {PALETTE} from '../styles/paletteV3'
import Checkbox from './Checkbox'
import StyledError from './StyledError'

const Wrapper = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  cursor: 'pointer'
})

const Text = styled('div')({
  fontWeight: 600,
  paddingRight: 8
})

const ErrorMessage = styled(StyledError)({
  paddingRight: 8
})

const StyledCheckbox = styled(Checkbox)({
  '&&': {
    width: 24,
    height: 24,
    marginRight: 8,
    color: PALETTE.SKY_500
  }
})





const EmailNotifications = (props) => {
  const {viewerRef} = props
  const atmosphere = useAtmosphere()
  const {error, onError, onCompleted} = useMutationProps()
  const {sendSummaryEmail} = useFragment(
    graphql`
      fragment EmailNotifications_viewer on User {
        sendSummaryEmail
      }
    `,
    viewerRef
  )

  const handleClick = () => {
    ToggleSummaryEmailMutation(atmosphere, {}, {onError, onCompleted})
  }

  return (
    _jsxs(Wrapper, { onClick: handleClick, children: [
      _jsx(StyledCheckbox, { active: sendSummaryEmail,} )
      , _jsx(Text, { children: 'Receive meeting summary emails'})
      , _jsx(ErrorMessage, { children: _optionalChain([error, 'optionalAccess', _ => _.message])})
    ]})
  )
}

export default EmailNotifications
